<template>
    <div class="grid">
        <div v-once >
            <div>
                <IconBase :iconName="iconName" :height="iconHeight" :width="iconWidth" class="icon" />
                <span class="font-4 title">{{title}}</span>
                <slot name="postTitle"></slot>
            </div>
            <div class="description font-7">
                <slot name="description"></slot>
            </div>
        </div>
        <div class="create-button">
            <Tooltip :text="disabledTooltip">
                <button type="button"
                        class="primary"
                        :disabled="isDisabled"
                        @click="$emit('createTestClick')">
                    Create Test
                </button>
            </Tooltip>
        </div>
    </div>


</template>

<script>
import IconBase from 'components/IconBase.vue';
import Tooltip from 'components/Tooltip/Tooltip.vue';

export default {
    name: 'CreationOption',
    components: { Tooltip, IconBase },
    props: {
        iconName: String,
        iconHeight: Number,
        iconWidth: Number,
        title: String,
        isDisabled: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        disabledTooltip() {
            return this.isDisabled ? 'Missing configurations: To create a test an app must be fully configured' : '';
        }
    }
};
</script>

<style scoped lang="scss">
@import "~styles/styleGuide";
@import "~styles/buttons";

.description {
    color: $light-800;
    margin-top: 15px;
    line-height: 22px;
}

.grid {
    display: grid;
    grid-template-columns: auto 160px;
    border: 1px solid $light-400;
    border-radius: $borderRadius;
    padding: 30px;
}

.icon {
    height: 24px;
    vertical-align: middle;
}

.create-button {
    align-self: center;
    text-align: end;
}

.title {
    color: $dark-300;
    margin-left: 5px;
}
</style>
